import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { setEncounterAction as setEncounter } from '../../../../services/EncounterService/slice';
import { EncounterType } from '../../../../services/EncounterService/types/encounterTypes';

const AdmissionSourceEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const encounter = useAppSelector((state) => state.encounter.currentEncounter);

  // Check if encounter is cancelled
  const isEncounterCancelled = encounter?.status === 'CANCEL';

  const admissionSources = [
    'ALLEN THERAPY CENTER - POSMC',
    'BUNDLED',
    'CANCELED',
    'CANCELLED',
    'CANCELLED VISIT',
    'COSMETIC',
    'CT SCAN',
    'DETOX',
    'DIR ADM',
    'DIRECT ADMISSION',
    'DIRECT ADMIT',
    'EMERGENCY ROOM',
    'ENT',
    'ER',
    'ER TO IP',
    'ER TO OBS',
    'FRISCO THERAPY CENTER - POSMC',
    'GENERAL SURGERY',
    'Imaging',
    'INACTIVE/UNUSED ACCTS',
    'Inpatient',
    'LABORATORY',
    'MRI',
    'O/P SURG',
    'OBS TO IP',
    'OBSERVATION',
    'OP Surgery',
    'ORTHO',
    'Other',
    'OUTPATIENT',
    'OUTPATIENT SURGERY',
    'P5 FRISCO PT',
    'P5 PLANO PT',
    'PAIN MANAGEMENT',
    'PERADM T',
    'PHYSICIAL THERAPY',
    'PLANO THERAPY CENTER - POSMC',
    'PLASTICS',
    'PODIATRY',
    'PRE ADMISSION TESTING',
    'PTC ALLEN',
    'PTC FRISCO NORTH',
    'PTC FRISCO WEST',
    'PTC MCKINNEY',
    'PTC PLANO WEST',
    'RADIOLOGY',
    'RESEARCH STUDY MRI PATIENTS',
    'RICHARDSON THERAPY CENTER - PO',
    'SPINE',
    'SURG IP',
    'SURG OBS',
    'SURG TO IP',
    'Surgery',
    'SURGERY TO IP',
    'SURGERY TO OBS',
    'Telemetry',
    'Therapy',
    'TREATMENT ROOM',
    'ULTRASOUND',
    'VASCULAR',
    'X-RAY'
  ];

  const handleChange = (value: string) => {
    if (!encounter) return;
    
    const updated = {
      ...encounter,
      encounterInfo: {
        ...encounter.encounterInfo,
        admissionSource: value,
      },
    } as EncounterType;
    dispatch(setEncounter(updated));
  };

  return (
    <TextField
      label="Admission Source"
      size="small"
      select
      value={encounter?.encounterInfo?.admissionSource || ''}
      onChange={(e) => handleChange(e.target.value)}
      disabled={isEncounterCancelled}
      sx={{ 
        width: '220px',
        '& .MuiInputBase-input': {
          backgroundColor: isEncounterCancelled ? '#f5f5f5' : 'inherit'
        }
      }}
      helperText={isEncounterCancelled ? 'Read-only (Encounter Cancelled)' : ''}
    >
      {admissionSources.map((source) => (
        <MenuItem key={source} value={source}>{source}</MenuItem>
      ))}
    </TextField>
  );
};

export default AdmissionSourceEdit;
